module.exports = __webpack_public_path__ + "img/almatyObl5.8aeedda5.jpg";